import RechargeListContainer from '../../../../Componant/Application/Ecommerce/master/RechargeListContainer'

const RechargeList = () => {
  return (
    <div className='page-body'>
      <RechargeListContainer />
    </div>
  )
}

export default RechargeList